import { render, staticRenderFns } from "./TyreChanges.vue?vue&type=template&id=9550f670"
import script from "./TyreChanges.vue?vue&type=script&lang=js"
export * from "./TyreChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports